import { render, staticRenderFns } from "./AlarmCurrent.vue?vue&type=template&id=48be13c1&scoped=true"
import script from "./AlarmCurrent.vue?vue&type=script&lang=js"
export * from "./AlarmCurrent.vue?vue&type=script&lang=js"
import style0 from "./AlarmCurrent.vue?vue&type=style&index=0&id=48be13c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48be13c1",
  null
  
)

export default component.exports